import versionData from '@/version.json'
import { HStack, Text } from '@chakra-ui/react'
import { deconstructVersion } from 'BrokerTsLib/src/Utils'

export const Footer = () => {

  const version = deconstructVersion(versionData.version)

  return <HStack as="footer"
    pointerEvents={'none'}
    position={'absolute'}
    bottom={0}
    right={0}
    left={0}
    maxW='full'
    py={2}
    px={6}
    justifyContent='end'
    flexWrap='wrap'
    gap={4}
  >
    <Text title={`Verze ${version.year}.${version.month}.${version.patch}, Build ${version.build}+${version.commit}`} pointerEvents={'auto'}>
      v{version.year}.{version.month}.{version.patch}
    </Text>
  </HStack>
}